import {
  GET_DEPARTMENT_OPTIONS,
  DEPARTMENT_OPTIONS_SUCCESS,
  DEPARTMENT_OPTIONS_ERROR,
  CREATE_DEPARTMENT,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_ERROR,
  GET_DEPARTMENT_LIST,
  DEPARTMENT_LIST_SUCCESS,
  DEPARTMENT_LIST_ERROR,
  UPDATE_DEPARTMENT,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_ERROR,
  COMPANY_LOGO,
} from '../type';
import axios from 'axios';
import {
  getDepartmentOptionsUrl,
  getDepartmentMasterList,
  postDepartment,
  putDepartment,
  getAllLofoList,
  getLogoUserCompanyId
} from '../../Component/Helpers/api';

import { toast } from 'react-toastify';

export const getDepartmentList = payload => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: GET_DEPARTMENT_LIST });
  axios
    .get(`${getDepartmentMasterList}/${payload.UserObj}/${payload.UserObj}/[${payload.LocationObj}]?pgno=${payload.pgno}&row=${payload.row}`, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({
          type: DEPARTMENT_LIST_SUCCESS,
          payload: res.data,
        });
      } else {
        dispatch({ type: DEPARTMENT_LIST_ERROR, payload: res.data.error });
      }
    })
    .catch(error => {
      dispatch({ type: DEPARTMENT_LIST_ERROR, payload: error });
    });
};

export const getDepartmentOptions = companyID => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: GET_DEPARTMENT_OPTIONS });
  axios
    .get(`${getDepartmentOptionsUrl}?company=${companyID}`, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: DEPARTMENT_OPTIONS_SUCCESS, payload: res.data.data });
      } else {
        dispatch({ type: DEPARTMENT_OPTIONS_ERROR, payload: res.data.error });
      }
    })
    .catch(error => {
      dispatch({ type: DEPARTMENT_OPTIONS_ERROR, payload: error });
    });
};

export const createDepartment = params => dispatch => {

  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: CREATE_DEPARTMENT });
  axios
    .post(postDepartment, params,{  headers: {

      Authorization: authToken?.spintlyToken,

    },})
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: CREATE_DEPARTMENT_SUCCESS });
        toast.success('Department created successfully', {
          
        });
        dispatch(getDepartmentList(params.company));
        // setTimeout(() => {
        //   window.location.reload();
        // }, 2000);
      } else {
        dispatch({ type: CREATE_DEPARTMENT_ERROR, payload: res.data.error });
      }
    })
    .catch(error => {
      dispatch({ type: CREATE_DEPARTMENT_ERROR, payload: error });
    });
};

export const updateDepartment = (params, company) => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: UPDATE_DEPARTMENT });
  axios
    .post(putDepartment, params, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: UPDATE_DEPARTMENT_SUCCESS });
        toast.success('Department Updated Successfully', {
          
        });
        dispatch(getDepartmentList(company));
        // setTimeout(() => {
        //   window.location.reload();
        // }, 2000);
      } else {
        dispatch({ type: UPDATE_DEPARTMENT_ERROR, payload: res.data.error });
      }
    })
    .catch(error => {
      toast.error(error.response.data.message, {
        
      });
      dispatch({ type: UPDATE_DEPARTMENT_ERROR, payload: error });
    });
};

export const getCompamyLogoList = () => {
  let authToken = JSON.parse(localStorage.getItem('headData'));
  return (dispatch) => {
    axios
      .get(`${getAllLofoList}`, {
       
        headers: {
          Authorization: `${authToken?.spintlyToken}`
        }})
      .then(res => {
        if (res.status === 200) {
          dispatch({
            type: COMPANY_LOGO,
            payload: res?.data?.logoData?.logo,
          })
        }
      })
  }
};
export const getCompamyLogoCompanyIdList = (companyId = 0) => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  return (dispatch) => {

    axios

      .get(`${getLogoUserCompanyId}?companyId=${companyId}`, {
       
        headers: {
          Authorization: `${authToken?.spintlyToken}`
        }})

      .then(res => {

        if (res.status === 200) {

          localStorage.setItem('clientLogoData', JSON.stringify(res.data))

        }

      })

  }

};
